import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TeamForm from "./teamComponents/TeamForm";

import { useAppMeta } from "hooks";

import {
  useGetTeamDetailQuery,
  useUpdateTeamMutation,
} from "store/services/teamApi";

const TeamEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Teams", path: "/app/crm/team/list" },
    { title: "Edit Team" },
  ];

  // RTK Query
  const {
    data: teamDetail,
    isLoading: loadingTeamDetail,
    error,
  } = useGetTeamDetailQuery(id);

  const [updateTeam, { isLoading: updatingTeam }] = useUpdateTeamMutation();

  // methods
  const handleUpdateTeam = async (data) => {
    try {
      await updateTeam(data).unwrap();
      toast.success("Team successfully updated!");
      navigate(breadcrumbs[0]?.path);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Team!");
    }
  };

  useAppMeta("Edit Team");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingTeamDetail || updatingTeam}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <TeamForm
          isBusy={loadingTeamDetail || updatingTeam}
          teamDetail={teamDetail}
          onSubmit={handleUpdateTeam}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TeamEditScreen;
